import { AnyAction } from "redux";
import { ADD_DATA, DELETE_DATA, GET_DATA, SAVE_DATA } from "../../../../action-types";

interface PersistedIntegration {
  id?: number;
}

export const loadIntegrationsAction = (shopId: string): AnyAction => ({
  type: GET_DATA,
  field: "integrations",
  shopId,
  meta: {
    type: "api",
    url: `shop/${shopId}/settings/integrations`,
    method: "get"
  }
});

export const addIntegrationAction = (
  shopId: string,
  type: string,
  integration: unknown
): AnyAction => ({
  type: ADD_DATA,
  newData: integration,
  shopId,
  field: `integrations`,
  pathInObject: type,
  meta: {
    type: "api",
    url: `shop/${shopId}/settings/integrations/${type}`,
    method: "post",
    data: integration
  }
});

export const saveIntegrationAction = (
  shopId: string,
  type: string,
  integration: PersistedIntegration
): AnyAction => ({
  type: SAVE_DATA,
  newData: integration,
  shopId,
  index: integration.id,
  field: `integrations`,
  pathInObject: type,
  meta: {
    type: "api",
    url: `shop/${shopId}/settings/integrations/${type}/items/${integration.id}`,
    method: "put",
    data: integration
  }
});

export const updateIntegrationAction = (
  type: string,
  shopId: string,
  index: number
): AnyAction => ({
  type: GET_DATA,
  field: "integrations",
  index,
  shopId,
  pathInObject: type,
  meta: {
    type: "api",
    url: `shop/${shopId}/settings/integrations/${type}/items/${index}`,
    method: "get"
  }
});

export const deleteIntegrationAction = (
  shopId: string,
  type: string,
  index: number
): AnyAction => ({
  type: DELETE_DATA,
  field: "integrations",
  index,
  shopId,
  pathInObject: type,
  meta: {
    type: "api",
    url: `shop/${shopId}/settings/integrations/${type}/items/${index}`,
    method: "delete"
  }
});
